import type { TFn } from "../i18nTypes";

/** A row's params, made readable by the host (#182): an exercise slug becomes
 *  its name, a canonical kilo value a weight in the athlete's unit. */
export type InboxParamFormatter = (
  params: Readonly<Record<string, string>>,
) => Record<string, string>;

// A phone row's params can hold numbers (its `count` drives plurals): they
// pass through untouched, and only the strings reach the formatter.
export type InboxParams = Record<string, string | number>;

// What the card and its actions interpolate. A param named `status` carries a
// raw server enum (feedback's open/in_progress/shipped/wontfix: SPEC "il suo
// stato come parametro"), resolved through the SAME per-locale vocabulary the
// feedback triage screen owns (feedback.status_*). The rest goes through the
// host's formatter, when there is one, and is otherwise display-ready.
export function displayParams(
  raw: Readonly<InboxParams> | undefined,
  t: TFn,
  format: InboxParamFormatter | undefined,
): InboxParams {
  const base: InboxParams = { ...(raw ?? {}) };
  if (typeof base.status === "string") {
    base.status = t(`feedback.status_${base.status}`, {
      defaultValue: base.status,
    });
  }
  if (!format) return base;
  const strings: Record<string, string> = {};
  for (const [key, value] of Object.entries(base))
    if (typeof value === "string") strings[key] = value;
  return { ...base, ...format(strings) };
}
